<template>
  <div>
    <template v-if="user">
      <v-menu close-on-click offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on" icon>
            <v-avatar size="32px" item>
              <v-img :src="user.data.photo_url" alt="GSV" />
            </v-avatar>
          </v-btn>
        </template>

        <v-list>
          <v-list-item :to="{ name: 'Profile' }">
            <v-list-item-title>Profil uporabnika {{ user.data.first_name }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item @click.prevent="signOut">
            <v-list-item-title>Odjava</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template v-else>
      <router-link to="login">Login</router-link>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    computed: {
      ...mapGetters(["user", "loggedIn"]),
    },
    methods: {
      signOut() {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        this.$store.dispatch("setUserData", null);
        this.$router.replace("/login");
      },
    },
  };
</script>
